<template>
  <div class="users" style="margin-left: 15%;margin-right: 15%;margin-top: 5%;">
    <el-container>
      <el-main>
        <div>
          <el-table
            :data="
              tableData.slice(
                (currentPage - 1) * pagesize,
                currentPage * pagesize
              )
            "
            border
            :default-sort="{ prop: 'date', order: 'descending' }"
            style="width: 100%"
          >
            <el-table-column label="用户名">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.username }}</span>
              </template>
            </el-table-column>
            <el-table-column label="email">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.email }}</span>
              </template>
            </el-table-column>
            <el-table-column label="是否为管理员">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.is_admin }}</span>
              </template>
            </el-table-column>
            <el-table-column label="注册时间">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{
                  dateTimeFormat(scope.row.register_date)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="上次登陆时间">
              <template slot-scope="scope">
                <i class="el-icon-time"></i>
                <span style="margin-left: 10px">{{
                  dateTimeFormat(scope.row.last_seen)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  class="deleteBtn"
                  size="mini"
                  type="danger"
                  @click="deleteUser(scope.row.username)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <el-footer>
        <div class="pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next"
            :total="tableData.length"
            prev-text="上一页"
            next-text="下一页"
            style="margin: auto;"
          >
          </el-pagination>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import { dateFormat } from "@/libs/date.js";

export default {
  name: "Users",
  data() {
    return {
      currentPage: 1, //默认显示页面为1
      pagesize: 10, //    每页的数据条数
      tableData: []
    };
  },
  methods: {
    dateTimeFormat(data) {
      return dateFormat("YYYY-mm-dd HH:MM:SS", new Date(Number(data * 1000)));
    },
    // 每页下拉显示数据
    handleSizeChange: function(size) {
      this.pagesize = size;
    },
    // 点击第几页
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
    },
    updateUser() {
      axios
        .get("/api/user/admin")
        .then(response => {
          this.tableData = response.data;
        })
        .catch(error => {
          this.tableData = [];
          this.$message.error(error.response.data.message);
        });
    },
    deleteUser(username) {
      axios
        .delete("/api/user/admin", {
          data: { username }
        })
        .then(() => {
          this.updateUser();
          this.$message.success("删除成功");
        })
        .catch(error => {
          this.$message.error(error.response.data.message);
        });
    }
  },
  created() {
    this.updateUser();
  }
};
</script>

<style scoped></style>
